/* eslint-disable
    guard-for-in,
    no-cond-assign,
    no-restricted-syntax,
    no-return-assign,
    no-unused-vars
*/
// TODO: This file was created by bulk-decaffeinate.
// Fix any style issues and re-enable lint.
/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * DS103: Rewrite code to no longer use __guard__
 * DS104: Avoid inline assignments
 * DS207: Consider shorter variations of null checks
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */
import * as Sentry from '@sentry/browser';
import _ from 'underscore';

import {assertAndContinue} from 'Asserts';
import BenchlingConfig from 'BenchlingConfig';
import localStorage from 'LocalStorage';
import ContentWorkers from 'notebook/workers/ContentWorkers';
import EntityStore from 'stores/EntityStore';
import * as logging from 'util/Logging';
import * as net from 'util/Net';
import APIUtil from 'util/APIUtil';

export const DRAFTS_KEY = 'localDrafts-v2';

function getLocalDrafts() {
  let left;
  return (left = localStorage.json.getItem(DRAFTS_KEY)) != null ? left : {};
}

function setLocalDrafts(drafts) {
  ContentWorkers.stringify(drafts).then((json) => {
    localStorage.setItem(DRAFTS_KEY, json);
  });
}

function postClientDump(extra, status, message) {
  if (status < 500) {
    logging.dump('drafts.postClientDump', `Failed to save draft [${status}] ${message}`, {
      data: {localDrafts: getLocalDrafts()},
      extra,
    });
  }
}

async function requestRecovery() {
  await net.postJSONPromise({
    url: '/1/api/debug/request-recovery',
    data: {
      localDrafts: getLocalDrafts(),
    },
  });
}

export default {
  RECOVERY_HASH: '#recover',

  RECOVERY_ID: 'recovery',

  getLocalDrafts,

  setLocalDrafts,

  postClientDump,

  requestRecovery,

  draftId(prefix, id) {
    return `${prefix}-${id}`;
  },

  apiIdFromDraftId(draftId) {
    return draftId.split('-')[1];
  },

  isRecoverable(draft) {
    const draftIsEntry = draft?.item?.id ? APIUtil.isEntry(draft.item.id) : false;
    return (
      draft != null &&
      draft.unsaved &&
      draft.author != null &&
      draft.author === __guard__(EntityStore.currentUser(), (x) => x.id) &&
      draftIsEntry
    );
  },

  shouldPromptForRecovery(draft) {
    return (
      this.isRecoverable(draft) && !draft.recovered && !draft.dismissed && !draft.lockedFromExternalChange
    );
  },

  recoverableDataExist() {
    return _.findKey(this.getLocalDrafts(), (draft) => this.shouldPromptForRecovery(draft)) != null;
  },

  removeDraft(draftId) {
    const localDrafts = getLocalDrafts();
    delete localDrafts[draftId];
    setLocalDrafts(localDrafts);
  },

  init() {
    // TODO(T###, 2016-07-15): The data stored in 'localDrafts' is not accurate due to bug T5729, so we've
    // switched to a new localStorage key: 'localDrafts-v2'. To avoid keeping around old data (which eats into
    // our 5MB), we immediately clear it.
    localStorage.removeItem('localDrafts');

    // If any files are older than a few days, we remove them from localStorage.
    const localDrafts = getLocalDrafts();
    for (const draftId in localDrafts) {
      const draft = localDrafts[draftId];
      if (new Date() - new Date(draft.timestamp) > 1000 * 60 * 60 * 24 * 3) {
        // 3 days
        delete localDrafts[draftId];
      }
    }
    setLocalDrafts(localDrafts);
  },
};

function __guard__(value, transform) {
  return value != null ? transform(value) : undefined;
}
